import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';

const CurrencySelect = ({ name, label = 'Document Currency', control, errors, readOnly = false }) => {
  const currencies = useSelector((state) => state.currencies.currencies);
  const currenciesOptions = currencies.map((item) => {
    const displayLabel = item.Code === 'MYR' ? 'RM' : item.Code;
    return `${displayLabel} - ${item.Currency}`;
  });

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Autocomplete
          {...field}
          name={name}
          options={currenciesOptions}
          readOnly={readOnly}
          renderInput={(params) => (
            <TextField
              sx={{ minWidth: '150px' }}
              {...params}
              label={label}
              error={!!errors[name]}
              helperText={errors[name]?.message}
            />
          )}
          onChange={(_, value) => field.onChange(value?.split(' - ')[0] === 'RM' ? 'MYR' : value?.split(' - ')[0])}
          value={field.value === 'MYR' ? 'RM' : field.value || null}
        />
      )}
    />
  );
};

export default CurrencySelect;
